import axios from "axios";

const fetchAdHoc = async (endpoint, filters) => {
  const params = new URLSearchParams();
  ["startDate", "endDate"].forEach((key) => {
    if (filters[key] != null && filters[key] !== "") params.append(key, filters[key]);
  });
  const res = await axios.get(`/api/analytics/adhoc/${endpoint}?${params.toString()}`);
  return res.data;
};

export const getAdHocSummary = (filters = {}) => fetchAdHoc("summary", filters);
export const getAdHocSearchVolume = (filters = {}) => fetchAdHoc("search-volume", filters);
export const getAdHocUniqueUsers = (filters = {}) => fetchAdHoc("unique-users", filters);
export const getAdHocHeatmap = (filters = {}) => fetchAdHoc("heatmap", filters);
export const getAdHocResultsQuality = (filters = {}) => fetchAdHoc("results-quality", filters);
